import React from 'react'

function Info({ messages, alertType }) {
  return (
    <div className='w-100 d-flex justify-content-center'>
      {messages &&
        messages.length > 0 &&
        messages.map((ele, index) => (
          <p key={index} className={`alert ${alertType}`}>
            <i
              className={`fas ${
                alertType === 'alert-success' ? 'fa-check-circle' : 'fa-exclamation-circle'
              } me-2`}></i>{' '}
            {ele.msg || ele}
          </p>
        ))}
    </div>
  )
}

export default Info
